import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InterceptorSkipModalError } from '../interceptor/interceptor';
import { Base } from './base';
import { environment } from 'src/environments/environment';
import { MINUTES, SECONDS } from '../const/time';

declare type HttpMethod = 'GET' | 'POST' | "PUT" | "DELETE";

export class BaseService<T> extends Base{

  public http = inject(HttpClient)
  public api = environment.API;
  protected path: string;


  constructor() {
    super()
  }

  public get<T>(id: string | number, skipModalError: boolean = false, skipTrackFeatureUsage: boolean = false): Observable<T>{
    return this.http.get<T>(this.api + this.path + "/" + id, {headers: this.addHeaders(skipModalError, skipTrackFeatureUsage), withCredentials: true})
  }

  public post<T1, T2 = T1>(t: T1, id: string | number = "", skipModalError: boolean = false, withCredentials: boolean = true): Observable<T2>{
    return this.http.post<T2>(this.api + this.path + (id ? "/" : ''  + id) + id, t, {headers: this.addHeaders(skipModalError), withCredentials: withCredentials})
  }

  public put<T>(t: T, id: string | number, skipModalError: boolean = false): Observable<T>{
    return this.http.put<T>(this.api + this.path + `/${id}`, t, {headers: this.addHeaders(skipModalError), withCredentials: true})
  }

  public delete<T>(id: string | number, skipModalError: boolean = false): Observable<T>{
     return this.http.delete<T>(this.api + this.path + `/${id}`, {headers: this.addHeaders(skipModalError), withCredentials: true})
  }

  public getAll<T>(param: string = "", skipModalError: boolean = false): Observable<T[]>{
    return this.http.get<T[]>(this.api + this.path + param, {headers: this.addHeaders(skipModalError), withCredentials: true})
  }

  public fetchRequest(endpoint: string, httpMethod: HttpMethod, headers: any): void {
    fetch(endpoint, {
      headers: headers,
      method: httpMethod,
      body: null,
      credentials: 'include',
      keepalive: true,
    })
  }

  protected addHeaders(skipModalError: boolean, skipFeatureUsageTrack: boolean = false) {
    return HttpHeadersBuilder.create()
                             .skipModalError(skipModalError)
                             .skipFeatureUsageTrack(skipFeatureUsageTrack)
                             .build();
  }
}

export class HttpHeadersBuilder {
  private readonly _headers: {[key: string]: string} = {};

  private constructor() {}

  public static create() {
    return new HttpHeadersBuilder();
  }

  public skipModalError(shouldSkip: boolean) {
    if (shouldSkip) {
      this._headers[InterceptorSkipModalError] = "";
    }

    return this;
  }

  public skipFeatureUsageTrack(shouldSkip: boolean) {
    if (shouldSkip) {
      this._headers["x-track-feature-usage"] = "false";
    }

    return this;
  }

  public build() {
    return this._headers;
  }
}
